import { getItemMaker } from "./tools";

const helmet = getItemMaker("premium helmets");
export const premiumHelmets = [
  helmet("Bandit Bob Mask"),
  helmet("Invisible Hat"),
  helmet("Hotdog Hero"),
  helmet("Parasite", "EquipmentHats34"),
  helmet("Giftmas Tree"),
  helmet("Pop Cat", "EquipmentHats47"),
  helmet("The Classic"),
  helmet("Green Beanie"),
  helmet("Big Bunny"),
  helmet("Fluffy Ramsy"),
  helmet("Ele Sorcerer Pointed Hat"),
  helmet("Borzoi Topper"),
  helmet("Yellow Beanie"),
  helmet("Bedsheet with Holes", "EquipmentHats85"),
  helmet("Carrotman Mask"),
  helmet("Glublin Mask"),
  helmet("Bloque Mask"),
  helmet("Giftmas Snoozy Cap"),
  helmet("The Red Boaty"),
  helmet("Corgi Topper"),
  helmet("Siege Captain Cap"),
  helmet("Straw Hat"),
  helmet("Wig Bandana"),
  helmet("Funky Hat"),
  helmet("Reinforced Headband"),
  helmet("Shogun Helmet"),
  helmet("Gilded Headband"),
  helmet("Bamboo Hat"),
  helmet("Festive Beast Mask"),
  helmet("Heiress Headdress"),
  helmet("Spirited Mane"),
  helmet("Fiery Mane"),
  helmet("Guardian Mane"),
  helmet("Fanned Blossomage"),
  helmet("Dainty Brim"),
  helmet("Charcoal Hat"),

  helmet("Pardoned Turkey"),
  helmet("Paper Bag", "EquipmentHats33"),
  helmet("Diamon Horns"),
  helmet("Halloween Pumpkin"),
  helmet("Strawbiggy"),
  helmet("Dairy Dunk"),
  helmet("Snowman"),
  helmet("Husky Hat", "EquipmentHats109"),
  helmet("Ice Cream Sundae", "EquipmentHatsBeg1"),
  helmet("Orange Beanie", "EquipmentHats117"),
  helmet("Farmer Brimest", "EquipmentHats24"),
];

const ring = getItemMaker("chat rings");
export const chatRings = [
  ring("Leafy Ring"),
  ring("Bob Ring"),
  ring("Bubble Ring"),
  ring("Love Ring"),
  ring("Wealth Ring"),
  ring("Cthulu's Ring"),
  ring("Lava Sez Buy More Gems"),
  ring("HONK Ring"),
  ring("Equinox Ring"),
  ring("Meteorite Ring"),
];

const cape = getItemMaker("capes");
export const capes = [
  cape("Timeless Watch"),
  cape("Giant Nightshade"),
  cape("Angel Wings"),
  cape("Easter Egg Backpack"),
  cape("Radiant Amarok Backstabber", "EquipmentCape3"),
  cape("Gilded Efaunt Dislodged Tusks"),
  cape("Blighted Chizoar Shard Cape"),
  cape("Cascading Scaled Cape of Krieg"),
  cape("Molten Cloak"),
  cape("Giant Rose", "EquipmentCape8"),
  cape("Giant Violet"),
  cape("Giant Starflower"),
  cape("Riftwalker Wings"),
  cape("Blooming Vine"),
  cape("Eternal Flames of The Divine"),
  cape("Phoenix Wings"),
];

const tag = getItemMaker("nametags");
export const nameTags = [
  tag("Lava's Awesome Nametag"),
  tag("Timeless Nametag"),
  tag("Nightshade Nametag"),
  tag("Riftwalker Nametag"),
  tag("Balling Nametag"),
  tag("Vman Nametag", "EquipmentNametag4"),
  tag("Spring Flowers Nametag"),
  tag("Trash Tuna Nametag"),
  tag("Island Adventurer Nametag"),
  tag("Summer Shovel Nametag"),
  tag("Falloween Nametag"),
  tag("3rd Anniversary IdleOn Nametag"),
  tag("Megafeather Nametag"),
  tag("Snowflake Nametag", "EquipmentNametag14"),
  tag("Frostyman Nametag", "EquipmentNametag15"),
  tag("Spectacular 4th Year Nametag", "EquipmentNametag17"),
  tag("4th Anniversary IdleOn Nametag", "EquipmentNametag18"),
];
